export default "__VITE_ASSET__ba265684__"